import axios from 'axios'

const state = {
    user: null
}

const getters = {
    isAuthenticated () {
        return state.user !== null
    },
    user () {
        return state.user
    }
}

const actions = {
    register ({commit}, data) {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + '/api/auth/register', data).then((response) => {
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error.response)
                })
        })
    }
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
